
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/prevision-apertura",
      function () {
        return require("private-next-pages/[region]/prevision-apertura.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/prevision-apertura"])
      });
    }
  